import {Component} from "./Component";
import {filterEventSelector} from "../util/event";
import {createLogger} from "../util/logger";

const console = createLogger("RepeatInput");

export class RepeatInput extends Component {
    static name = "repeat-input";

    get name() {
        return RepeatInput.name;
    }

    constructor(el) {
        super(el);

        /**
         * @type {HTMLElement[]}
         */
        this.$rows = Array.from(document.querySelectorAll(this.getAttributeSelector("row")));

        this.maxRows = this.el.getAttribute(this.getAttributeString() + "-max") || -1;
        this.maxRows = parseInt(this.maxRows, 10);

        this.$btnAddRow = this.$("btnAddRow");

        this.addEventListener(this.$btnAddRow, "click", this.onClickAddRow.bind(this));

        this.addEventListener(this.el, "click",
            filterEventSelector(this.getAttributeSelector("btnRemoveRow"), this.onClickRemoveRow.bind(this))
        );

        this.updateAddRowBtn();

        console.log(this);

    }

    onClickAddRow() {
        this.addRow();
    }

    /**
     * @param {MouseEvent} e
     */
    onClickRemoveRow(e) {
        const $row = e.target.closest(this.getAttributeSelector("row"));
        this.removeRow($row);
    }

    addRow() {
        if (this.maxRows > 0) {
            if (this.$rows.length >= this.maxRows) return;
        }

        const $firstRow = this.$rows[0];

        console.log("addRow", this.$rows);

        const $newRow = $firstRow.cloneNode(true);
        $newRow.querySelectorAll("label").forEach((label) => {
            const id = label.getAttribute("for") + "-" + this.$rows.length;

            label.setAttribute("for", id);

            const input = label.parentElement.querySelector("input");
            if (!input) return;
            input.setAttribute("id", id);
            input.name = input.name.replace("[0]", `[${this.$rows.length}]`);
        });

        this.$rows.push($newRow);
        this.el.insertBefore($newRow, this.$("btnAddRow"));

        console.log("row added", this.$rows.length, this.maxRows);
        this.updateAddRowBtn();
    }

    updateAddRowBtn() {
        if (this.$rows.length === this.maxRows) {
            this.$btnAddRow.classList.add("add-row--hidden");
            this.$btnAddRow.disabled = true;
        }
    }

    removeRow($row) {
        const index = this.$rows.indexOf($row);

        if (this.$rows.length <= 1) return;

        this.$rows.splice(index, 1);
        $row.remove();

        if (this.$rows.length < this.maxRows) {
            this.$btnAddRow.classList.remove("add-row--hidden");
            this.$btnAddRow.disabled = false;
        }
    }

    reset() {
        this.$rows.slice(1).forEach((row) => this.removeRow(row));
    }

}
